import { type AnchorHTMLAttributes, type MouseEvent, type ReactNode, forwardRef } from "react"
import { navigate } from "./next-navigation"

type LinkProps = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> & {
  href: string
  children?: ReactNode
}

const Link = forwardRef<HTMLAnchorElement, LinkProps>(function Link(
  { href, onClick, target, children, ...props },
  ref,
) {
  return (
    <a
      {...props}
      href={href}
      target={target}
      ref={ref}
      onClick={(event: MouseEvent<HTMLAnchorElement>) => {
        onClick?.(event)
        if (
          event.defaultPrevented ||
          event.button !== 0 ||
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey ||
          target === "_blank" ||
          href.startsWith("#")
        ) {
          return
        }
        const targetUrl = new URL(href, window.location.href)
        if (targetUrl.origin !== window.location.origin) return
        event.preventDefault()
        navigate(href)
      }}
    >
      {children}
    </a>
  )
})

export default Link
